import NewFeatureBanner from "./NewFeatureBanner";

export default NewFeatureBanner;
